module.exports = __webpack_public_path__ + "img/home_testimonial2.b211651.png";